import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA  } from '@angular/material';
import { NgForm } from '@angular/forms';

@Component({
  selector: 'app-tagprescription',
  templateUrl: './tagprescription.component.html',
  styleUrls: ['./tagprescription.component.css']
})
export class TagprescriptionComponent implements OnInit {
  filename: any;
  uploadFile: any;
  hasBaseDropZoneOver = false;
  options: Object = {
    url : 'https://passport.petcart.in/images/petimages/index.php'
    };
    sizeLimit = 2000000;
     public hasAnotherDropZoneOver = false;
     public fileOverAnother(e: any): void {
       this.hasAnotherDropZoneOver = e;
     }
  constructor(public DialogRef: MatDialogRef<TagprescriptionComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() {
  }
  handleUpload(data): void {
    if (data && data.response) {
        data = JSON.parse(data.response);
        this.uploadFile = data;
        this.filename = data.originalName;
     }
    }
    fileOverBase(e: any): void {
      this.hasBaseDropZoneOver = e;
    }

    beforeUpload(uploadingFile): void  {
      if (uploadingFile.size >  this.sizeLimit) {
        uploadingFile.setAbort();
        alert('File is too large');
      }
    }
    UploadComplete() {
      this.DialogRef.close(this.filename);
    }
}
